import axios from "axios";
import axiosRetry from "axios-retry";

import store from "./store";
import { selectAccessToken } from "./selector/authSelectors";

const addResponseErrorInterceptor = client => {
  client.interceptors.response.use(
    response => response,
    err => {
      err.status = err.response ? err.response.status : undefined;
      err.data = err.response ? err.response.data : undefined;
      return Promise.reject(err);
    }
  );
};

const addAuthInterceptor = client => {
  client.interceptors.request.use(config => {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${selectAccessToken(store.getState())}`
      }
    };
  });
};

export const applicationServicesClient = axios.create({
  baseURL: window.__APPLICATION_SERVICES__
});
addAuthInterceptor(applicationServicesClient);
addResponseErrorInterceptor(applicationServicesClient);
axiosRetry(applicationServicesClient, { retries: axiosRetry.exponentialDelay });
